import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Dropdown, DropdownMenuItem, Icon, H5 } from '../../../../../components';

const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  cursor: default;
  &:hover {
    background-color: transparent;
  }
`;

const SchedulesDropdown = ({
  onScheduleClick,
  onCustomScheduleClick,
  currentSchedule,
  toggleComponent
}) => (
  <Dropdown menuPlacement='bottom-end' menuStyle={{ width: 200 }} toggleComponent={toggleComponent}>
    {() => (
      <>
        <StyledDropdownMenuItem disabled>
          <H5 color='var(--content-subtitle)'>Refresh schedule</H5>
        </StyledDropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onScheduleClick({ isActive: false, cronSchedule: currentSchedule?.cronSchedule })
          }
          disabled={currentSchedule === null || !currentSchedule?.isActive}
          rightIcon={
            (currentSchedule === null || !currentSchedule?.isActive) && (
              <Icon displaySize={20} name='check' />
            )
          }
        >
          Off
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={currentSchedule?.isActive && currentSchedule?.cronSchedule === '0 7 * * *'}
          rightIcon={
            currentSchedule?.isActive &&
            currentSchedule?.cronSchedule === '0 7 * * *' && <Icon displaySize={20} name='check' />
          }
          onClick={() =>
            onScheduleClick({
              cronSchedule: `0 7 * * *`,
              timezone: 'America/New_York',
              isActive: true
            })
          }
        >
          Every day
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={currentSchedule?.isActive && currentSchedule?.cronSchedule === '0 7 * * 1'}
          rightIcon={
            currentSchedule?.isActive &&
            currentSchedule?.cronSchedule === '0 7 * * 1' && <Icon displaySize={20} name='check' />
          }
          onClick={() =>
            onScheduleClick({
              cronSchedule: `0 7 * * 1`,
              timezone: 'America/New_York',
              isActive: true
            })
          }
        >
          Weekly on Monday
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onCustomScheduleClick}
          rightIcon={
            currentSchedule?.isActive &&
            currentSchedule?.cronSchedule !== '0 7 * * *' &&
            currentSchedule?.cronSchedule !== '0 7 * * 1' && <Icon displaySize={20} name='check' />
          }
        >
          Custom
        </DropdownMenuItem>
      </>
    )}
  </Dropdown>
);

SchedulesDropdown.defaultProps = {
  currentSchedule: null
};

SchedulesDropdown.propTypes = {
  onScheduleClick: PropTypes.func.isRequired,
  onCustomScheduleClick: PropTypes.func.isRequired,
  currentSchedule: PropTypes.shape({
    id: PropTypes.string,
    cronSchedule: PropTypes.string,
    isActive: PropTypes.bool
  }),
  toggleComponent: PropTypes.node.isRequired
};

export { SchedulesDropdown };
